import script from "./filters-section-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./filters-section-header.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__